/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerWarnings
 */
export interface SuccessCardTransactionEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'detectedDpi'?: SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'calculatedDpi'?: SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'colorGradation'?: SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'heightMillis'?: SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerWarnings
     */
    'widthMillis'?: SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum;
}

export const SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsDetectedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsCalculatedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsColorGradationEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsHeightMillisEnum];
export const SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum = typeof SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerWarningsWidthMillisEnum];


